import {
  Box,
  Button,
  CircularProgress,
  MenuItem,
  Modal,
  Select,
} from "@mui/material";
import React, {
  useCallback,
  useEffect,
  useMemo,
  useRef,
  useState,
} from "react";
import DeleteIcon from "@mui/icons-material/Delete";
import { STATES } from "../../../shared/constants";
import { useDispatch, useSelector } from "react-redux";
import { uploadImage } from "../../auth/service";
import { cityActions } from "../duck/CityReducer";

const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: '90%',
  maxWidth: '800px',
  maxHeight: '90vh',
  bgcolor: 'background.paper',
  boxShadow: 24,
  p: 2,
  overflowY: 'auto',
  '&::-webkit-scrollbar': {
    width: '4px',
  },
  '&::-webkit-scrollbar-track': {
    background: '#f1f1f1',
  },
  '&::-webkit-scrollbar-thumb': {
    background: '#888',
    borderRadius: '4px',
  },
  '&::-webkit-scrollbar-thumb:hover': {
    background: '#555',
  },
  '@media (min-width: 600px)': {
    width: '80%',
    p: 3,
  },
  '@media (min-width: 900px)': {
    width: '70%',
  },
  '@media (min-width: 1200px)': {
    width: '60%',
  },
};

const AddCityModal = (props) => {
  const { open, handleClose, selectedCityId, onCityUpdated } = props;

  const prevProp = useRef();
  const dispatch = useDispatch();
  const selectedCity = useSelector(
    ({ city }) => city?.citiesMap?.[selectedCityId]
  );

  console.log("🧭 selectedCityId:", selectedCityId);
  console.log("🏙️ selectedCity from Redux:", selectedCity);

  const [isUploadingImg, setIsUploadingImg] = useState(false);
  const [cityDetails, setCityDetails] = useState({
    state: "",
    city: "",

    map: "",
    imgAlt: "",
    src: "",

    active: true,
  });
  const [error, setError] = useState({});

  // useEffect(() => {
  //   if (!prevProp?.current?.open && open) {
  //     setCityDetails({
  //       state: selectedCity?.state ?? "",
  //       map: selectedCity?.map ?? "",

  //       city: selectedCity?.city ?? "",

  //       imgAlt: selectedCity?.images?.[0]?.imgAlt ?? "",
  //       src: selectedCity?.images?.[0]?.src ?? "",
  //       // active: selectedCity?.active ?? "",

  //       active:
  //         typeof selectedCity?.active === "string"
  //           ? selectedCity?.active === "true"
  //           : selectedCity?.active ?? false,
  //     });
  //     setError({});
  //   }

  //   return () => {
  //     prevProp.current = {
  //       open,
  //     };
  //   };
  // }, [open, selectedCity,selectedCityId]);

  // useEffect(() => {
  //   if (open && selectedCityId && selectedCity) {
  //     setCityDetails({
  //       state: selectedCity?.state ?? "",
  //       map: selectedCity?.map ?? "",
  //       city: selectedCity?.city ?? "",
  //       imgAlt: selectedCity?.images?.[0]?.imgAlt ?? "",
  //       src: selectedCity?.images?.[0]?.src ?? "",
  //       active:
  //         typeof selectedCity?.active === "string"
  //           ? selectedCity?.active === "true"
  //           : selectedCity?.active ?? false,
  //     });
  //     setError({});
  //   }
  // }, [open, selectedCityId, selectedCity]);

  useEffect(() => {
    if (open) {
      if (selectedCityId && selectedCity) {
        setCityDetails({
          state: selectedCity?.state ?? "",
          map: selectedCity?.map ?? "",
          city: selectedCity?.city ?? "",
          imgAlt: selectedCity?.images?.[0]?.imgAlt ?? "",
          src: selectedCity?.images?.[0]?.src ?? "",
          active:
            typeof selectedCity?.active === "string"
              ? selectedCity?.active === "true"
              : selectedCity?.active ?? false,
        });
      } else {
        // Reset to empty when adding a new city
        setCityDetails({
          state: "",
          city: "",
          map: "",
          imgAlt: "",
          src: "",
          active: true,
        });
      }
      setError({});
    }
  }, [open, selectedCityId, selectedCity]);

  const handleChange = useCallback(
    (name) => (e) => {
      let value = e?.target?.value ?? e;

      setCityDetails((preState) => ({ ...preState, [name]: value }));
      setError({});
    },
    []
  );

  const modalTitle = useMemo(
    () => (selectedCityId ? "Edit City" : "Add City"),
    [selectedCityId]
  );

  const hasError = useCallback(() => {
    let { state, city, map, src } = cityDetails;
    state = state?.trim?.();
    city = city?.trim?.();
    map = map?.trim?.();

    const error = {};
    if (!state) {
      error.state = "Please select state";
    }
    if (!city) {
      error.city = "Please enter city name";
    }

    if (!map) {
      error.map = "Please provide embed link";
    }

    if (!src) {
      error.fileList = "Upload city icon";
    }

    // if (!active) {
    //   error.status = "Select Status";
    // }

    setError(error);
    return Object.keys(error).length;
  }, [cityDetails]);

  // const getSelectedFile = useCallback(async (e) => {
  //   let formData = new FormData();
  //   try {
  //     setIsUploadingImg(true);
  //     const file = e.target.files[0];
  //     formData.append("image", file);

  //     const res = await uploadImage(formData);
  //     if (res.status === "success") {
  //       const image = res?.data?.Location;
  //       setCityDetails((prevData) => ({ ...prevData, src: image }));
  //       setError({});
  //     }
  //     else {
  //     // API returned error → show message from backend
  //     setError({ fileList: res?.message || "Something went wrong" });
  //   }
  //     // setError({});
  //   } catch (error) {
  //     // setError("Something went wrong");
  //      if (error?.response?.data?.message) {
  //     setError({ fileList: error?.response?.data?.message }); // e.g., "File too large"
  //   } else {
  //     setError({ fileList: "Something went wrong" });
  //   }
  //   } finally {
  //     setIsUploadingImg(false);
  //   }
  // }, []);


// const getSelectedFile = useCallback(async (e) => {
//   const file = e.target.files[0];
//   if (!file) return;

//   let formData = new FormData();
//   formData.append("image", file);

//   try {
//     setIsUploadingImg(true);

//     const res = await uploadImage(formData);

//     if (res.status === "success") {
//       // Upload succeeded → clear errors
//       const image = res?.data?.Location;
//       setCityDetails((prevData) => ({ ...prevData, src: image }));
//       setError({});
//     } else {
//       // API returned error object in a non-2xx response
//       console.log('this is error message',res?.message)
//       setError({ fileList: res?.message || "Something went wrong test" });
//     }

//   } catch (err) {
//     // Handle backend error from failed requestres?.message
//     // Some APIs send error in err.response.data.message
//     const backendMessage =
//       err?.response?.data?.message || // Axios style error
//       err?.message ||                 // Fetch or generic JS error
//       "Something went wrong";
// console.log('backendMessage',backendMessage)
//     setError({ fileList: backendMessage });
//   } finally {
//     setIsUploadingImg(false);
//   }
// }, []);



const getSelectedFile = useCallback(async (e) => {
  const file = e.target.files[0];
  if (!file) return;

  let formData = new FormData();
  formData.append("image", file);

  try {
    setIsUploadingImg(true);

    const res = await uploadImage(formData);

    // If API returns a successful status
    if (res.status === "success") {
      setCityDetails((prev) => ({ ...prev, src: res?.data?.Location }));
      setError({});
    } else {
      // If API returns an error with a message
      setError({ fileList: res?.message || "File too large" });
    }

  } catch (err) {
    // If the request fails (e.g., 400, 500) and API returns { message: "..." }
    const message =
      err?.response?.data?.message || // Axios style
      err?.message ||                 // generic JS error
      "Something went wrong test";

    setError({ fileList: message });
  } finally {
    setIsUploadingImg(false);
  }
}, []);


  const onSubmit = useCallback(() => {
    console.log("🟡 onSubmit called", cityDetails, selectedCityId);

    if (!hasError()) {
      console.log("✅ No form error, proceeding with update/create");

      const payload = {
        ...cityDetails,
        images: [
          {
            imgAlt: cityDetails?.imgAlt,
            src: cityDetails?.src,
          },
        ],
      };
      if (selectedCityId) {
        payload._id = selectedCityId;
        dispatch(cityActions.onUpdateCity(payload));
        if (onCityUpdated) onCityUpdated(payload);

        console.log("🟩 Dispatching UPDATE payload:", payload);
      } else {
        // console.log("🟦 Dispatching CREATE payload:", payload);

        // dispatch(cityActions.onCreateCity(payload));

        console.log("🟦 Dispatching CREATE payload:", payload);

        // create a temporary city object for immediate UI update
        const tempCity = {
          ...payload,
          _id: Date.now().toString(), // temporary ID for UI
        };

        // call parent callback to update UI immediately
        if (props.onCityAdded) props.onCityAdded(tempCity);

        // still dispatch to backend
        dispatch(cityActions.onCreateCity(payload));
      }

      handleClose();
    } else {
      console.log("❌ Validation failed:", error);
    }
  }, [cityDetails, dispatch, handleClose, selectedCityId, hasError]); //hasError

  return (
    <Modal open={open} onClose={handleClose}>
      <Box sx={style}>
        <h2>{modalTitle}</h2>
        <div className="form_comp">
          <label htmlFor="title">
            State
            <sup style={{ color: "red" }}>*</sup>
          </label>
          <Select
            style={{ height: 40 }}
            value={cityDetails.state}
            onChange={handleChange("state")}
          >
            {STATES.map((state, i) => (
              <MenuItem key={i} value={state}>
                {state}
              </MenuItem>
            ))}
          </Select>

          <span className="error mt5">{error.state}</span>
        </div>
        <div className="form_comp">
          <label htmlFor="title">
            City
            <sup style={{ color: "red" }}>*</sup>
          </label>
          <input
            type="text"
            placeholder="Enter city"
            value={cityDetails.city}
            onChange={handleChange("city")}
            autoComplete="off"
          />
          <span className="error mt5">{error.city}</span>
        </div>

        <div className="form_comp">
          <label htmlFor="title">
            Status
            <sup style={{ color: "red" }}>*</sup>
          </label>
          <Select
            style={{ height: 40 }}
            value={cityDetails.active}
            onChange={handleChange("active")}
          >
            <MenuItem value={true}>Active</MenuItem>
            <MenuItem value={false}>Inactive</MenuItem>
          </Select>
        </div>

        <div className="form_comp">
          <label htmlFor="title">
            Map
            <sup style={{ color: "red" }}>*</sup>
          </label>
          <textarea
            rows="2"
            placeholder="Enter iframe"
            value={cityDetails.map}
            onChange={handleChange("map")}
          />
          <span className="error mt5">{error.map}</span>
        </div>

        <div className="form_comp">
          <label htmlFor="title">
            City Icon <sup style={{ color: "red" }}>*</sup>
          </label>
          {!cityDetails?.src ? (
            <>
              {isUploadingImg ? (
                <CircularProgress />
              ) : (
                <Button
                  variant="contained"
                  className="bordered-button"
                  style={{ width: 200, fontSize: 14, color: "#fff" }}
                  component="label"
                >
                  Upload Image
                  <input
                    type="file"
                    accept="image/*"
                    onChange={getSelectedFile}
                    hidden
                  />
                </Button>
              )}
            </>
          ) : (
            <>
              <div style={{ maxWidth: 400 }} className="mUpload-item">
                <img src={cityDetails?.src} width="80px" alt="img" />
                <input
                  className="fw"
                  type="text"
                  placeholder="Enter alt tag"
                  value={cityDetails?.imgAlt}
                  onChange={handleChange("imgAlt")}
                />
                <DeleteIcon
                  onClick={() =>
                    setCityDetails((preState) => ({ ...preState, src: "" }))
                  }
                />
              </div>
            </>
          )}
          <span className="error mt5">{error.fileList}</span>
        </div>

        <div
          style={{
            marginTop: 20,
            display: "flex",
            gap: 15,
          }}
        >
          <Button variant="contained" onClick={onSubmit}>
            {selectedCity ? "Update" : "Add"}
          </Button>
          <Button
            variant="text"
            className="bordered-button"
            onClick={handleClose}
          >
            Cancel
          </Button>
        </div>
      </Box>
    </Modal>
  );
};

export default AddCityModal;
